export {Properties} from './Properties';
